import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper, { Navigation, Pagination, Keyboard, Lazy } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

Swiper.use([Navigation, Pagination, Keyboard, Lazy]);

export default class extends Controller {
  initializeSwiper() {
    this.swiper = new Swiper(".js-event-detail-modal-slider", {
      lazy: true,
      loop: true,
      slidesPerView: 1,
      initialSlide: this.slideIndex,
      pagination: {
        el: ".js-event-detail-modal-slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-event-detail-modal-slider-next",
        prevEl: ".js-event-detail-modal-slider-prev",
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
  }

  handleResize() {
    const slideCount = $(".js-event-detail-modal-slider").find(".swiper-slide").length;

    if (slideCount === 1) {
      this.destroySwiper();
    } else {
      if (!this.swiper) {
        this.initializeSwiper();
      }
    }
  }

  modalShow(e) {
    e.preventDefault();
    this.destroySwiper();
    this.slideIndex = $(e.currentTarget).data("swiper-slide-index");
    this.handleResize();
  }
}
